import React from 'react';

const VideoTranscript = () => {
    return (
        <details id="video-transkript" role="region" aria-label="Transkription des Videos" className="p-4">
            <summary className="transcript-summary"><i className="fa fa-file-o"></i> Transkription anzeigen</summary>
            <div className="transcript-text">
                <pre>
                    Das Video zeigt in schneller Abfolge Momente aus verschiedenen Reisezielen.<br/>
                    <strong>[00:00]</strong> Zuerst ein Kloster am Ohridsee in Nordmazedonien. Boote gleiten im hellen Vormittagslicht vorbei.<br/>
                    <strong>[00:02]</strong> Danach der Eiffelturm in Paris, als Silhouette vor einem orangefarbenen Abendhimmel. Mehrere Flugzeugstreifen kreuzen den Himmel.<br/>
                    <strong>[00:05]</strong> Es folgt der Swayambhunath-Tempel in Kathmandu, Nepal. Das goldene Dach glänzt in der Sonne, bunte Gebetsfahnen flattern, Menschen bewegen sich geschäftig.<br/>
                    <strong>[00:07]</strong> Der Itsukushima-Schrein in Japan steht ruhig im Wasser, in warmes Abendlicht getaucht.<br/>
                    <strong>[00:09]</strong> In London zeigt die Kamera Big Ben, das Parlament und das London Eye. Schiffe und Autos sind unterwegs – es ist früher Morgen.<br/>
                    <strong>[00:13]</strong> Zum Schluss eine Luftaufnahme der Pyramiden bei Kairo. Die Kamera fliegt darüber hinweg. Im hellen Sonnenlicht fällt der Schatten der Pyramide nach Westen.<br/>
                </pre>
            </div>
        </details>
    )
}

export default VideoTranscript;